import React, { useContext, useMemo } from 'react'

const EMPTY_LIST = []

const FormPageContext = React.createContext({
  formDirection: '',
  formDoctor: '',
  serviceDirections: EMPTY_LIST,
  pageSpecialists: EMPTY_LIST,
  fillFromSpecialists: false,
})

export function FormPageProvider({
  formDirection = '',
  formDoctor = '',
  serviceDirections = EMPTY_LIST,
  pageSpecialists = EMPTY_LIST,
  fillFromSpecialists = false,
  children,
}) {
  const serviceKey = serviceDirections.join('\0')
  const specialistKey = pageSpecialists.join('\0')
  const value = useMemo(
    () => ({
      formDirection,
      formDoctor,
      fillFromSpecialists,
      serviceDirections: serviceKey ? serviceKey.split('\0') : EMPTY_LIST,
      pageSpecialists: specialistKey ? specialistKey.split('\0') : EMPTY_LIST,
    }),
    [formDirection, formDoctor, fillFromSpecialists, serviceKey, specialistKey]
  )

  return <FormPageContext.Provider value={value}>{children}</FormPageContext.Provider>
}

export function useFormPage() {
  return useContext(FormPageContext)
}
